export const padTo2Digits = (num: number) => {
  return num.toString().padStart(2, '0');
};
